/** @jsxImportSource @emotion/react */
import { useRef } from 'react';
import AnalysisTable from './components/AnalysisTable';
import { OpinionSaveHandle } from './components/AnalysisOpinionSection';
import ChatBot from './components/ChatBot';
import MechUtAnalysisSection from './components/MechUtAnalysisSection';
import OpinionSection from './components/OpinionSection';
import SummaryCards from './components/SummaryCards';
import SummarySection from './components/SummarySection';
import TornadoSection from './components/TornadoSection';
import UtMatrixSelector from './components/UtMatrixSelector';
import UtTabs from './components/UtTabs';
import { Root } from './styles';

/**
 * UT Utility Consumption Comparison Tool
 * - 레거시 UT Matrix(UTM_ID) 최대 3개 비교 — Machine별 UT 사용량 차이 분석 & Excel/PPT 산출
 * - 내부 프로젝트 통합 시 이 컴포넌트를 서브 라우트 element로 삽입 (스타일은 Root로 스코핑됨)
 */
const UtComparisonPage = () => {
  /**
   * 화면의 저장 버튼은 ⑦ 하단 하나뿐이다. ⑥이 ⑦ 밖으로 나오면서 형제가 됐으므로
   * 여기서 ref를 만들어 양쪽에 물려준다 — ⑦의 저장이 ⑥의 save()까지 함께 호출한다.
   */
  const mechUtRef = useRef<OpinionSaveHandle>(null);

  return (
    <Root>
      {/* 페이지 타이틀/브레드크럼은 AppShell(레거시 셸)이 렌더링 — 여기는 콘텐츠만 */}
      <div className="container">
        <UtMatrixSelector />
        {/* 표시 옵션·Excel/PPT 산출은 ② 안으로 들어갔다 (같이 접히도록) — ControlsBar는 UtTabs가 그린다 */}
        <UtTabs />
        <SummaryCards />
        <AnalysisTable />
        <SummarySection />
        {/*
          ⑥ 자리 — 규칙 기반으로 문구를 만들어 보여주던 "종합 분석"(ComprehensiveSection)을
          걷어내고 UT 항목별 분석결과를 올렸다. ⑦ 안에 있던 걸 끌어올린 것이라
          저장된 리포트를 열었을 때(historyRptId)만 보이는 건 그대로다.
        */}
        <MechUtAnalysisSection ref={mechUtRef} />
        <OpinionSection mechUtRef={mechUtRef} />
        {/*
          ⑧ 증가/감소 설비 도표 — ①~⑦이 이미 차 있어 다음 번호로 채웠다.
          ⑦의 저장 버튼(GlobalBtnGroup)이 ⑦ 상자 밖에 있어서, 이 섹션은 그 아래에 놓인다.
          읽기 전용 도표라 저장 흐름과 섞이지 않는다.
        */}
        <TornadoSection />
      </div>

      {/* <ChatBot /> */}
    </Root>
  );
};

export default UtComparisonPage;
